// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"c37d679f","227":"75443c90","252":"2e33f5c8","453":"b2188b53","809":"f0ae9a96"}[chunkId] + ".chunk.js";
};